import { AxiosResponseHeaders } from "axios";
import { IApiClient } from "../api-client";
import { EnvType } from "../services";
import { DbInvoiceExpenseInfos } from "../Types/db-invoice-expense-infos";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetInvoiceResponse } from "../Types/get-invoice-response";
import { GetMySubscriptionResponse } from "../Types/get-my-subscription-response";
import { ListExpensesResponse } from "../Types/list-expenses-response";
import { ListInvoicesResponse } from "../Types/list-invoices-response";
import { ListSubscriptionOffersResponse } from "../Types/list-subscription-offers-response";
import { UpdateMySubscriptionRequest } from "../Types/update-my-subscription-request";

export interface IBillingApiClient {
  ListInvoices(): Promise<ListInvoicesResponse>;
  GetInvoice(id: number): Promise<GetInvoiceResponse>;
  ValidateInvoice(id: number): Promise<GenericResponseStd>;
  ListCurrentExpenses(): Promise<ListExpensesResponse>;
  AddExpenseOnInvoice(request: DbInvoiceExpenseInfos): Promise<GenericResponseStd>;
  GetMySubscription(): Promise<GetMySubscriptionResponse>;
  UpdateMySubscription(request: UpdateMySubscriptionRequest): Promise<GenericResponseStd>;
  ListSubscriptionOffers(): Promise<ListSubscriptionOffersResponse>;
  DownloadBillingInvoicePdfExport(objectId: number): Promise<[string, AxiosResponseHeaders]>;
  GetApiUrl(): string;
}

export default class BillingApiClient implements IBillingApiClient {
  readonly servicePort = 9520;
  readonly serviceBaseUrl = "billing-service/api";

  billingApiClient: IApiClient;

  constructor(dataApiClient: IApiClient, envType: EnvType) {
    this.billingApiClient = dataApiClient;
    if (envType === "local") this.billingApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async ListInvoices(): Promise<ListInvoicesResponse> {
    return await this.billingApiClient.get(`${this.serviceBaseUrl}/invoices`);
  }
  async GetInvoice(id: number): Promise<GetInvoiceResponse> {
    return await this.billingApiClient.get(`${this.serviceBaseUrl}/invoices/${id}`);
  }
  async ValidateInvoice(id: number): Promise<GenericResponseStd> {
    return await this.billingApiClient.put(`${this.serviceBaseUrl}/invoices/validate/${id}`);
  }
  async ListCurrentExpenses(): Promise<ListExpensesResponse> {
    return await this.billingApiClient.get(`${this.serviceBaseUrl}/expenses`);
  }
  async AddExpenseOnInvoice(request: DbInvoiceExpenseInfos): Promise<GenericResponseStd> {
    return await this.billingApiClient.post(`${this.serviceBaseUrl}/expenses`, request);
  }
  async GetMySubscription(): Promise<GetMySubscriptionResponse> {
    return await this.billingApiClient.get(`${this.serviceBaseUrl}/subscription`);
  }
  async UpdateMySubscription(request: UpdateMySubscriptionRequest): Promise<GenericResponseStd> {
    return await this.billingApiClient.put(`${this.serviceBaseUrl}/subscription`, request);
  }
  async ListSubscriptionOffers(): Promise<ListSubscriptionOffersResponse> {
    return await this.billingApiClient.get(`${this.serviceBaseUrl}/subscription/offers`);
  }
  async DownloadBillingInvoicePdfExport(id: number): Promise<[string, AxiosResponseHeaders]> {
    return await this.billingApiClient.getWithHeaders(
      `${this.serviceBaseUrl}/billing-invoice/${id}/pdf`,
      "arraybuffer"
    );
  }

  //------Utils------
  GetApiUrl(): string {
    return this.billingApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
